import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepDataBridgeService } from './step-modules/root-step/services/step-data-bridge.service';
import { StepCacheService } from './step-modules/services/step-cache.service';
import { stepNavigationGuard } from './step-navigation/stepNavigationGuard';
import { legacyUrlGuardGuard } from './app-guards/legacy-url-guard.guard';
import { legacySlugGuard } from './app-guards/legacy-slug.guard';

const routes: Routes = [
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule) },
  {
    path: ':companySlug/cookies',
    loadChildren: () => import('./core/cookies/cookies.module').then((m) => m.CookiesModule),
  },
  { path: 'login', loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule) },
  { path: 'ar', loadChildren: () => import('./configurator/configurator.module').then((m) => m.ConfiguratorModule) },
  {
    path: 'company/:companyId/offer/:offerId',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    // dummy component; won't render because guard returns a redirect UrlTree
    canActivate: [legacyUrlGuardGuard],
  },
  {
    path: 'company/:slug/series/:seriesId/product/:productId',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),

    canActivate: [legacyUrlGuardGuard],
  },
  // generic legacy slug redirect (no backend lookup)
  {
    path: 'company/:companyslug',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [legacySlugGuard],
  },
  {
    path: 'step',

    loadChildren: () =>
      import('./step-modules/custom-steps/shopping-cart-step/shopping-cart-step.module').then(
        (m) => m.ShoppingCartStepModule,
      ),
  },
  //{ path: 'company-select-step', redirectTo: 'cookies' },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'steps',
  },
  {
    path: '',
    loadChildren: () => import('./step-navigation/step-navigation.module').then((m) => m.StepNavigationModule),
    providers: [StepDataBridgeService, StepCacheService],
    canMatch: [stepNavigationGuard],
  },

  //{ path: '**', loadChildren: () => import('./configurator/configurator.module').then((m) => m.ConfiguratorModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
